// Утилиты для работы с реферальными ссылками

// Сохраняем ref ID в localStorage
export const saveReferralId = (refId) => {
  if (refId && refId.trim()) {
    localStorage.setItem('referralId', refId.trim());
    console.log('Referral ID saved:', refId);
  }
};

// Получаем ref ID из localStorage
export const getReferralId = () => {
  return localStorage.getItem('referralId') || '';
};

// Извлекаем ref ID из URL параметров
export const extractReferralFromUrl = (location) => {
  const urlParams = new URLSearchParams(location.search);
  const refId = urlParams.get('') || urlParams.get('ref'); // поддерживаем оба варианта: ?=value и ?ref=value

  if (refId) {
    saveReferralId(refId);
  }

  return refId;
};

// Очищаем реферальный ID
export const clearReferralId = () => {
  localStorage.removeItem('referralId');
};
